// Fonction helper pour récupérer un paramètre sans tenir compte de la casse
export const getParamCaseInsensitive = (
  queryParams: URLSearchParams,
  paramName: string,
): string | null => {
  for (const [key, value] of queryParams.entries()) {
    if (key.toLowerCase() === paramName.toLowerCase() && value !== 'undefined') {
      return value
    }
  }
  return null
}
